import LogoMonogram from '../../src/legacy/LogoMonogram.tsx';
export default LogoMonogram;
